import { RoutineTestGender } from 'modules/donor/components/RoutineTestGenderSelect/enum';

export const animalGender = Object.values(RoutineTestGender).map((value) => {
  return {
    value,
    label: value,
  };
});
